export default function getInput(name: string): HTMLInputElement | null {
  return document.querySelector(`[name="${name}"]`)
}
